<template>
  <div class="home">
    <Page :paramsProps="{}" ref="tableData" />
    <div slot="footer" class="dialog-footer">
      <el-button type="danger" @click="onSubmit" size="small" icon="el-icon-check">提交</el-button>
      <el-button type="danger" @click="closeModal" size="small" icon="el-icon-close">关闭</el-button>
    </div>
  </div>
</template>

<script>
import request from '@/found/utils/request';
import Page from './list';

export default {
  name: 'addForm',
  props: {
    formConfig: Object,
  },
  components: {
    Page,
  },
  methods: {
    // 关闭弹窗
    closeModal() {
      this.$emit('onClose');
    },
    onSubmit() {
      if (this.$refs.tableData.selectRow && this.$refs.tableData.selectRow.length > 0) {
        const customerNameList = this.$refs.tableData.selectRow.map((v) => v.customerName) || [];
        const customerNames = customerNameList.join('、');
        this.$confirm(`是否确认将${customerNames}绑定为合并考核账户？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            const params = this.$refs.tableData.selectRow.map((v) => ({
              mainCustomerCode: this.formConfig.row.customerCode,
              mainCustomerName: this.formConfig.row.customerName,
              customerCode: v.customerCode,
              customerName: v.customerName,
            }));
            const url = '/mdm/mdmcustmainsubrelation/assessSave';
            request.post(url, params).then((res) => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '操作成功',
                });
                this.$emit('onClose');
                this.$emit('onGetList');
              }
            });
          });
      }
    },
  },
};
</script>

<style lang='less' scoped>
.home {
  height: calc(100vh - 166px);
}
</style>
